module.exports = __webpack_public_path__ + "media/gallery/2-61a42015.jpg";